import { render, staticRenderFns } from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue?vue&type=template&id=c07ed04a"
import script from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue?vue&type=script&lang=js"
import style0 from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue?vue&type=style&index=0&id=c07ed04a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports